import React from 'react';

export function IconPhone({ className }) {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4996 10.1073V12.1396C13.5003 12.3283 13.4616 12.515 13.3859 12.6879C13.3102 12.8608 13.1991 13.016 13.0598 13.1435C12.9205 13.271 12.756 13.3681 12.577 13.4286C12.3979 13.489 12.2081 13.5115 12.0198 13.4945C9.93114 13.268 7.92479 12.5557 6.16201 11.4148C4.52197 10.3747 3.1315 8.98699 2.08935 7.3502C0.942206 5.58292 0.228313 3.5708 0.00550943 1.47687C-0.0114529 1.28953 0.0108547 1.10073 0.0710116 0.922473C0.131168 0.744216 0.227857 0.580414 0.35492 0.441494C0.481984 0.302575 0.636639 0.191582 0.809039 0.115583C0.981438 0.0395834 1.16781 0.000242813 1.35627 6.56786e-05H3.3926C3.72202 -0.00317004 4.04137 0.11325 4.29114 0.327626C4.54091 0.542002 4.70405 0.839706 4.75016 1.16525C4.8361 1.81563 4.9955 2.45421 5.2253 3.06883C5.31662 3.3113 5.33639 3.57481 5.28225 3.82815C5.22812 4.08149 5.10235 4.31402 4.91985 4.49821L4.0578 5.35855C5.02408 7.05453 6.43111 8.45878 8.13046 9.42314L8.99251 8.5628C9.17706 8.38066 9.41006 8.25514 9.6639 8.20111C9.91774 8.14709 10.1818 8.16681 10.4247 8.25796C11.0406 8.4873 11.6804 8.64638 12.3321 8.73216C12.6618 8.77858 12.9629 8.94433 13.1782 9.19789C13.3935 9.45144 13.5078 9.77511 13.4996 10.1073Z"
        fill="white"
      />
    </svg>
  );
}
